import script from "./ComponentLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComponentLoader.vue?vue&type=script&lang=ts&setup=true"

import "./ComponentLoader.vue?vue&type=style&index=0&id=01310c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01310c3a"]])

export default __exports__